<template>
  <div>
    <v-dialog v-model="dialog" max-width="1200" scrollable persistent>
      <v-card>
        <v-card-title>
          {{ campaign.d_r_c_cards_count }} Carte(s)
          <v-spacer/>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="pa-8">

          <div class="d-flex align-center ">
            <div>
              <v-text-field
                  v-model="keyword"
                  append-icon="mdi-magnify"
                  clearable
                  dense
                  filled
                  persistent-hint
                  placeholder="GIFT-XXXXXXX"
                  rounded
              ></v-text-field>
            </div>
          </div>

          <v-skeleton-loader v-if="isLoading" type="table"/>

          <v-data-table v-else
                        :search="keyword"
                        :headers="headers"
                        :items="cards"
                        class="table-border rounded-lg"
          >
            <template v-slot:item.voucher.code="{ item }">
              <span class="font-weight-bold">
                {{ item.voucher.code }}
              </span>
            </template>

            <template v-slot:item.voucher.amount="{ item }">
              <span class="font-weight-light">
                {{ CurrencyFormatting(item.voucher.amount) }}
              </span>
            </template>

            <template v-slot:item.status="{ item }">
              <v-btn depressed
                     small
                     dark
                     :color="statusColor(item.status)"
                     class="text-uppercase">
                {{ item.status }}
              </v-btn>
            </template>
          </v-data-table>

        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  data() {
    return {
      dialog: false,
      keyword: null,
      isLoading: false,
      campaign: {},
      cards: [],
      headers: [
        {text: 'Lot', value: 'delivery_refill_campaign.note'},
        {text: 'Code', value: 'voucher.code'},
        {text: 'Montant', value: 'voucher.amount'},
        {text: 'Expiré le', value: 'delivery_refill_campaign.expiry_date'},
        {text: 'Réservée', value: 'reserved'},
      ],
    };
  },
  methods: {
    statusColor(status) {
      switch (status) {
        case "created":
          return "blue lighten-2";
        case "shipped":
          return "orange lighten-2";
        case "delivered":
          return "green lighten-2";
        case "printed":
          return "red lighten-2";
        case "used":
          return "gifty lighten-2";
        default:
          return "grey lighten-2";
      }
    },
    open(item) {
      this.dialog = true
      this.campaign = item
      this.showCards()
    },
    showCards() {
      this.isLoading = true
      HTTP.get('/v1/refill-card-delivery/' + this.campaign.id + '/cards').then(res => {
        this.cards = res.data.data.d_r_c_cards
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
  },
};
</script>

<style scoped>

</style>